module.exports = __webpack_public_path__ + "assets/marionettejs.6f1c81fb.svg";